'use strict'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { Route, Router, Switch } from 'react-router-dom'
import { TidewaysContext } from './app/context'
import history from './app/history'
import Loader from './app/loader'
import TidewaysRoute from './app/route'
import store from './app/store'
import { Trace } from './domain/Trace'
import NotFound from './helper/not_found'
import { parseQueryString } from './helper/queryString'
import PublicTrace from './public-trace'
import { TraceEntity } from './redux/traces/TracesState'
import { FULFILLED } from './redux/V2/action-helper'
import { FETCH_TRACE } from './redux/V2/Trace/actions'
import AppRouter, { BackendRoute } from './router'
import PublicTraceDiff from './public_trace_diff'

interface DataPublic {
    tidewaysContext: TidewaysContext
    routes: { [name: string]: BackendRoute }
    user: any
    trace: TraceEntity
    baseTrace?: TraceEntity
    traceRaw: Trace
    baseTraceRaw?: Trace
}

// https://www.typescriptlang.org/docs/handbook/declaration-merging.html#global-augmentation
declare global {
    interface JQuery {
        appPublic: any
    }
}

;(jQuery => {
    jQuery.fn.appPublic = function(options) {
        jQuery.extend({}, jQuery.fn.appPublic.defaults, options)

        return jQuery(this).each(function() {
            const container = jQuery(this)[0]
            const root = createRoot(container)
            const appData: DataPublic = jQuery(container).data('app-public')
            const tidewaysContext = new TidewaysContext(appData.tidewaysContext)
            const router = new AppRouter(history, appData.routes, tidewaysContext, appData.user)
            router.routeAliases = {
                'XhprofProfilerBundle.Profile.quick': 'XhprofCoreBundle.Public.sharedTrace.quick',
            }
            const { trace, traceRaw, baseTrace, baseTraceRaw } = appData

            store.dispatch({ type: 'TIDEWAYS_INIT', tidewaysContext, router })

            store.dispatch({ type: 'TIDEWAYS_SHARED_TRACE', trace })
            store.dispatch({ type: FULFILLED(FETCH_TRACE), payload: { data: traceRaw } })

            if (baseTrace) {
                store.dispatch({ type: 'TIDEWAYS_SHARED_TRACE', trace: baseTrace })
                store.dispatch({ type: FULFILLED(FETCH_TRACE), payload: { data: baseTraceRaw } })
            }

            const loader = new Loader(store, router, undefined)
            history.listen(location => {
                loader.loadContentForPath(location.pathname, parseQueryString(history.location.search))
            })
            loader.loadContentForPath(history.location.pathname, parseQueryString(history.location.search))

            root.render(
                <Provider store={store as any}>
                    <Router history={history}>
                        <Switch>
                            {TidewaysRoute(router, 'XhprofCoreBundle.Public.sharedTrace', PublicTrace, {
                                traceId: trace.profile?.id || 'unknown',
                            })}
                            {TidewaysRoute(router, 'XhprofCoreBundle.Public.sharedTrace.flamegraph', PublicTrace, {
                                traceId: trace.profile?.id || 'unknown',
                                view: 'flamegraph',
                            })}
                            {TidewaysRoute(router, 'XhprofCoreBundle.Public.sharedTrace.quick', PublicTrace, {
                                traceId: trace.profile?.id || 'unknown',
                                view: 'timeline',
                            })}
                            {TidewaysRoute(router, 'XhprofCoreBundle.Public.sharedTrace.summary', PublicTrace, {
                                traceId: trace.profile?.id || 'unknown',
                                view: 'summary',
                            })}
                            {TidewaysRoute(router, 'XhprofCoreBundle.Public.sharedTrace.callgraph', PublicTrace, {
                                traceId: trace.profile?.id || 'unknown',
                                view: 'callgraph',
                            })}
                            {TidewaysRoute(router, 'XhprofCoreBundle.Public.sharedTrace.bottlenecks', PublicTrace, {
                                traceId: trace.profile?.id || 'unknown',
                                view: 'bottlenecks',
                            })}
                            {TidewaysRoute(router, 'XhprofCoreBundle.Public.sharedTrace.compare', PublicTraceDiff, {
                                traceId: trace.profile?.id || 'unknown',
                                baseTraceId: baseTrace?.profile?.id || 'unknown',
                                view: 'flamegraph',
                            })}
                            {TidewaysRoute(router, 'XhprofCoreBundle.Public.sharedTrace.callgraphCompare', PublicTraceDiff, {
                                traceId: trace.profile?.id || 'unknown',
                                baseTraceId: baseTrace?.profile?.id || 'unknown',
                                view: 'callgraph',
                            })}
                            {TidewaysRoute(router, 'XhprofCoreBundle.Public.sharedTrace.summaryCompare', PublicTraceDiff, {
                                traceId: trace.profile?.id || 'unknown',
                                baseTraceId: baseTrace?.profile?.id || 'unknown',
                                view: 'summary',
                            })}
                            {TidewaysRoute(router, 'XhprofCoreBundle.Public.sharedTrace.flamegraphCompare', PublicTraceDiff, {
                                traceId: trace.profile?.id || 'unknown',
                                baseTraceId: baseTrace?.profile?.id || 'unknown',
                                view: 'flamegraph',
                            })}
                            {/* If we do not handle URL yet, pass URL through Symfony stack */}
                            <Route component={NotFound} />
                        </Switch>
                    </Router>
                </Provider>,
            )
        })
    }
    jQuery.fn.appPublic.defaults = {}
})(jQuery)

// @ts-ignore
window.pluginRegistry.register({ selector: '[data-app-public]', invoke: 'appPublic', isReact: true })
